import React, { useState, useEffect, useRef, useCallback } from 'react';
import './employeeHome.css'
import Home from '../../../components/Home/HomeBox'
import CaseloadReport from '../../../components/Reports_V2/CaseloadReport'
import TimesheetsReport from '../../../components/Reports_V2/TimesheetsReport'
import MTSummaryReport from '../../../components/Reports_V2/SupportCoordinationReports/MTSummaryReport'
import CaseManagerCaseload from '../../../components/Reports_V2/CaseManagerCaseload';
import CaseInfo from '../../../components/CaseInfo/CaseInfo';
import axios from 'axios'
import { APIURL } from '../../../config'
import IRecordSync from '../../../components/forms/BulkUploadForm/IRecordSync'
import SupportCoordinatorManagement from '../../Manager/SupportCoordinatorManagement';
import SupportCoordinatorCustomers from '../../SupportCoordinator/SupportCoordinatorCustomers'
import NewNote from '../../SupportCoordinator/Modals/NewNote';
import NewTask from '../../SupportCoordinator/Modals/NewTask';
import NewTimesheet from '../../SupportCoordinator/Modals/NewTimesheet';
import Upload from '../../SupportCoordinator/Modals/Upload';
import moment from 'moment';
import { ButtonGroup, Button, Tabs, Tab } from '@mui/material';
import GridLayoutComponent from 'src/components/GridLayoutComponent/GridLayoutComponent';

const EmployeeHome = (props) => {
    const [dataLoading, setDataLoading] = useState(true);
    const [sDataLoading, setSDataLoading] = useState(true);
    const [value, setValue] = useState('1');
    const [data, setData] = useState(null);
    const [sData, setSData] = useState(null);
    const [MTSummaryData, setMTSummaryData] = useState([]);
    const [reportLoading, setReportLoading] = useState(true);

    const [showAddNote, setShowAddNote] = useState(false);
    const [showUpload, setShowUpload] = useState(false);
    const [showTask, setShowTask] = useState(false);
    const [showTimesheet, setShowTimesheet] = useState(false);

    const [noteCustomerID, setNoteCustomerID] = useState();
    const [uploadCustomerID, setUploadCustomerID] = useState("");
    const [timesheetCustomerID, setTimesheetCustomerID] = useState("")

    const fetchRowsRef = useRef(null);
    const registerFetchRows = useCallback((fetcher) => {
        fetchRowsRef.current = fetcher || null;
    }, []);

    const handleShowNote = (id) => { setNoteCustomerID(id); setShowAddNote(true) };
    const handleShowUpload = (id) => { setUploadCustomerID(id); setShowUpload(true) };
    const handleShowTask = () => setShowTask(true);
    const handleCloseTask = () => setShowTask(false);
    const handleShowTimesheet = (id) => { setTimesheetCustomerID(id); setShowTimesheet(true) };
    const handleCloseTimesheet = () => setShowTimesheet(false);

    const pBusinessType = props.user?.comp_settings.find(setting => setting.feature_value === 'primaryBusinessType') ? props.user.comp_settings.filter((setting) => setting.feature_value === "primaryBusinessType")[0].feature_id : -1;
    const isSubscibedToTimeManagement = props.user.subs.find((setting) => setting.feature_id === 12) ? true : false;
    const isNJ = props.user.comp_settings.find(setting => setting.feature_id === 99 && setting.state_id === 'NJ');
    const isSupport = props.user.comp_settings.find(setting => setting.feature_id === 101 && setting.feature_value === 'primaryBusinessType') && isNJ;
    const isServiceProvider = props.user.comp_settings.find(setting => setting.feature_id === 102 && setting.feature_value === 'primaryBusinessType');
    const isCaseManagement = props.user.comp_settings.find(setting => setting.feature_id === 104 && setting.feature_value === 'primaryBusinessType');

    const getEmployees = async () => {
        let data = await axios.get(APIURL + "/monthlymonitoring/manager/data", {
            params: {
                comp_id: props.comp_id,
                emp_id: props.user.emp_id,
                start: moment().subtract(2, 'months').startOf('month').format('YYYY-MM-DD'),
                end: moment().endOf('month').format('YYYY-MM-DDT23:59:59')
            }
        });

        setData(data.data);
        console.log(data.data);
        setDataLoading(false);
    }

    const getSCH = async () => {
        let data = await axios.get(APIURL + "/customers/SCH", {
            params: {
                comp_id: props.comp_id,
                emp_id: props.user.emp_id,
                start: moment().subtract(11, 'months').startOf('month').format('YYYY-MM-DD'),
                end: moment().endOf('month').format('YYYY-MM-DDT23:59:59'),
            }
        });
        setSData(data.data)
        setSDataLoading(false);
        console.log(data.data)
    }

    useEffect(() => {
        const fetchData = async () => {
            props.checkTokenExpiry();
            if (isSupport) {
                await getEmployees();
            }
        }
        fetchData();
    }, [props])

    const handleTimesheetCreated = () => {
        fetchRowsRef.current?.({ skipCache: true });
        getEmployees();
    };

    const getMTSummaryReport = async () => {
        axios
            .get(APIURL + "/reports/getMTSummary", {
                params: { com_id: props.user.comp_id, emp_id: props.user.emp_id },
            })
            .then((response) => {
                setMTSummaryData(response?.data.length !== 0 ? response?.data : []);
                setReportLoading(false);
            })
            .catch((err) => {
                setReportLoading(false);
                console.log(err);
            });
    }

    return (
        <div>
            {isCaseManagement ?
                <div>
                    <Tabs
                        indicatorColor="primary"
                        textColor="primary"
                        value={value}>
                        <Tab onClick={() => setValue('1')} label="Home" value="1" />
                        <Tab onClick={() => setValue('2')} label="Caseload Report" value="2" />
                        {isSubscibedToTimeManagement && <Tab onClick={() => setValue('3')} label="Timesheets Report" value="3" />}
                        {props.user.type === 'Admin' && !!props.user.subs.find((d) => d.feature_id === 16) && <Tab onClick={() => setValue('4')} label="Dashboard" value="4" />}
                    </Tabs>
                    {value === '1' &&
                        <div>
                            {props.user.type === 'Admin' && <CaseInfo user={props.user} checkTokenExpiry={props.checkTokenExpiry} />}
                            <GridLayoutComponent
                                {...props}
                                checkTokenExpiry={props.checkTokenExpiry}
                                user={props.user}
                                comp_id={props.comp_id}
                                onRegisterFetchRows={registerFetchRows}
                            />
                        </div>
                    }
                    {value === '2' &&
                        <div style={{ width: '98%', marginLeft: '1%' }}>
                            <CaseManagerCaseload user={props.user} comp_id={props.comp_id} />
                        </div>
                    }
                    {value === '3' &&
                        <div style={{ width: '98%', height: '100vh', marginLeft: '1%' }}>
                            <TimesheetsReport user={props.user} pagesize={20} comp_id={props.comp_id} />
                        </div>
                    }
                    {value === '4' &&
                        <div style={{ width: 1300 }}>
                            <Home {...props} checkTokenExpiry={props.checkTokenExpiry} user={props.user} comp_id={props.comp_id} />
                        </div>
                    }
                </div> :
                <div>
                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                        <Tabs
                            indicatorColor="primary"
                            textColor="primary"
                            variant="scrollable"
                            value={value}
                        >
                            <Tab onClick={() => setValue('1')} label="Home" value="1" />
                            {isSupport && props.user.type === 'Admin' ?
                                <Tab onClick={() => { getMTSummaryReport(); setValue('2') }} label="Caseload Report" value="2" />
                                :
                                <Tab onClick={() => setValue('2')} label="Caseload Report" value="2" />
                            }
                            {!!props.user.subs.find((d) => d.feature_id === 12) && <Tab onClick={() => setValue('3')} label="Timesheets Report" value="3" />}
                            {props.user.type === 'Admin' && !!props.user.subs.find((d) => d.feature_id === 16) && <Tab onClick={() => setValue('4')} label="Dashboard" value="4" />}
                            {props.user.type !== 'Fieldworker' && isSupport && <Tab onClick={() => setValue('5')} label="DDD Sync" value="5" />}
                            {isSupport && <Tab onClick={() => setValue('6')} label="SC Management" value="6" />}
                            {isSupport && <Tab onClick={() => setValue('7')} label="Customers" value="7" />}
                        </Tabs>
                        <ButtonGroup size="small" sx={{ height: "40px", whiteSpace: "nowrap" }}>
                            {(isSupport || isServiceProvider) && <Button variant="contained" onClick={() => setShowAddNote(true)}>NEW NOTE</Button>}
                            {(isSupport || isServiceProvider) && <Button variant="contained" onClick={handleShowTask}>NEW TASK</Button>}
                            {isSubscibedToTimeManagement && <Button variant="contained" onClick={handleShowTimesheet}>NEW TIMESHEET</Button>}
                            {(isSupport || isServiceProvider) && <Button size="small" variant="contained" onClick={() => setShowUpload(true)}>UPLOAD</Button>}
                        </ButtonGroup>
                    </div>
                    {value === '1' &&
                        <GridLayoutComponent
                            {...props}
                            checkTokenExpiry={props.checkTokenExpiry}
                            user={props.user}
                            comp_id={props.comp_id}
                            onRegisterFetchRows={registerFetchRows}
                            handleShowNote={handleShowNote}
                            handleShowUpload={handleShowUpload}
                            handleShowTimesheet={handleShowTimesheet}
                            sData={sData ? sData : []}
                            sDataLoading={sDataLoading}
                            data={data ? data : []}
                            getSCH={getSCH}
                            getEmployees={getEmployees}
                            dataLoading={dataLoading}
                        />
                    }
                    {value === '2' &&
                        (isSupport && props.user.type === 'Admin' ?
                            (reportLoading ?
                                <div className='d-flex flex-row w-100 justify-content-center mt-5'>
                                    <div className="spinner-border text-primary" role="status">
                                        <span className="sr-only">Loading...</span>
                                    </div>
                                </div> :
                                <div style={{ width: '100%' }}>
                                    <MTSummaryReport user={props.user} source={'Home'} />
                                </div>
                            )
                            :
                            <div style={{ width: '98%', marginLeft: '1%' }}>
                                <CaseloadReport user={props.user} pagesize={20} comp_id={props.comp_id} />
                            </div>
                        )
                    }
                    {value === '3' &&
                        <div style={{ width: '98%', height: '100vh', marginLeft: '1%' }}>
                            <TimesheetsReport user={props.user} pagesize={20} comp_id={props.comp_id} />
                        </div>
                    }
                    {value === '4' &&
                        <div style={{ width: 1300 }}>
                            <Home {...props} checkTokenExpiry={props.checkTokenExpiry} user={props.user} comp_id={props.comp_id} />
                        </div>
                    }
                    {value === '5' && isSupport &&
                        <div style={{ width: 1300, paddingLeft: '30px' }}>
                            <IRecordSync comp_id={props.comp_id} {...props}></IRecordSync>
                        </div>
                    }
                    {value === '6' && isSupport &&
                        <div className="customers-container">
                            <SupportCoordinatorManagement {...props} handleShowNote={handleShowNote} handleShowUpload={handleShowUpload} data={data ? data : []} comp_id={props.comp_id} emp_id={props.user.emp_id} getSCH={getSCH} getEmployees={getEmployees} loading={dataLoading} />
                        </div>
                    }
                    {value === '7' && isSupport &&
                        <div className="customers-container">
                            <SupportCoordinatorCustomers
                                {...props}
                                handleShowNote={handleShowNote}
                                handleShowUpload={handleShowUpload}
                                handleShowTimesheet={handleShowTimesheet}
                                onRegisterFetchRows={registerFetchRows}
                                data={sData ? sData : []}
                                comp_id={props.comp_id}
                                emp_id={props.user.emp_id}
                                loading={sDataLoading}
                                isSubscibedToTimeManagement={isSubscibedToTimeManagement}
                            />
                        </div>
                    }
                    {(isSupport || isServiceProvider) &&
                        <div>
                            <NewNote checkTokenExpiry={props.checkTokenExpiry} showAddNote={showAddNote} setShowAddNote={setShowAddNote} company_id={props.comp_id} mode='add' user={props.user} customer_id={noteCustomerID} setNoteCustomerID={setNoteCustomerID}></NewNote>
                            <NewTask show={showTask} handleClose={handleCloseTask} user={props.user} emp_id={props.user.emp_id} comp_id={props.comp_id} {...props} />
                            {isSubscibedToTimeManagement && <NewTimesheet show={showTimesheet} handleClose={handleCloseTimesheet} comp_id={props.comp_id} user={props.user} emp_id={props.user.emp_id} customer_id={timesheetCustomerID} setTimesheetCustomerID={setTimesheetCustomerID} onTimesheetCreated={handleTimesheetCreated}></NewTimesheet>}
                            <Upload showUpload={showUpload} setShowUpload={setShowUpload} company_id={props.comp_id} user={props.user} customer_id={uploadCustomerID} setUploadCustomerID={setUploadCustomerID} rerender={getSCH}></Upload>
                        </div>
                    }
                </div>
            }
        </div>
    )
}

export default EmployeeHome;